import type { FC } from 'react';

import { PostCreationOptionsScreen } from '@/features/post-editor/screens/PostCreationHomeScreen';
import { PostCreationContext } from '@/features/post-editor/types/postCreationOptions';
import type {
  AppNativeStackScreenProps,
  AppRoute
} from '@/navigation/types/navigation';

type Props = AppNativeStackScreenProps<typeof AppRoute.PostCreationRegion>;

export const PostCreationRegionScreen: FC<Props> = ({ route, navigation }) => (
  <PostCreationOptionsScreen
    navigation={navigation}
    creationContext={PostCreationContext.MEINE_REGION}
    channelType={route.params?.channelType}
  />
);
